"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const FieldsSetupFlowController_1 = __importDefault(require("../modules/controllers/FieldsSetupFlowController"));
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
let EconomicTable = class EconomicTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.fieldsChecked = [];
        this.isCheckedGlobal = false;
    }
    get fields() {
        return this.fieldsFilters;
    }
    fieldSetSizeUnit() {
        this.controller.data.fields.forEach((field) => {
            field.setAcreageUnit();
        });
    }
    parcelFillColor(field) {
        var _a;
        if (field.crop) {
            return `${(_a = field.crop) === null || _a === void 0 ? void 0 : _a.color}50`;
        }
        else
            return '#eebb5450';
    }
    parcelStrokeColor(field) {
        var _a;
        if (field.crop) {
            return (_a = field.crop) === null || _a === void 0 ? void 0 : _a.color;
        }
        else
            return '#eebb54';
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 45, 45);
    }
    selectField(field) {
        this.pushFn(field);
        this.$emit('drawNewFieldInMap');
    }
    fieldExists(fieldId) {
        return this.controller.data.selectedFields.some(field => field.id === fieldId);
    }
    isFieldCheck(fieldId) {
        if (this.fieldsChecked.includes(fieldId)) {
            return true;
        }
        return false;
    }
    resetGisAreasChecked() {
        this.fieldsChecked = [];
    }
    changeIsCheckedGlobal(newValue) {
        this.fieldsChecked = [];
        this.controller.resetSelectedFields();
        this.isCheckedGlobal = newValue;
    }
    checkedGlobalObserver() {
        if (this.isCheckedGlobal) {
            for (const field of this.fields) {
                this.fieldsChecked.push(field.id);
                this.controller.addSelectedFields(field);
            }
        }
        else {
            if (this.fieldsChecked.length < 1) {
                this.controller.resetSelectedFields();
                this.fieldsChecked = [];
            }
        }
    }
    pushFn(field) {
        if (this.isCheckedGlobal) {
            this.isCheckedGlobal = false;
        }
        if (this.fieldExists(field.id)) {
            /* this.STEP_MODEL.data.selectedFields = this.STEP_MODEL.data.selectedFields.filter((fieldT)=>{fieldT.id !== field.id}); */
            this.controller.removeSelectedField(field.id);
            //this.$emit('clearMap')
            if (this.controller.data.selectedFields.length < 1) {
                this.resetGisAreasChecked();
            }
        }
        else {
            this.controller.addSelectedFields(field);
        }
    }
    updateSelectedFields() {
        this.resetGisAreasChecked();
        this.isCheckedGlobal = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], EconomicTable.prototype, "controller", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], EconomicTable.prototype, "fieldsFilters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], EconomicTable.prototype, "textFilter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isCheckedGlobal')
], EconomicTable.prototype, "checkedGlobalObserver", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('fields')
], EconomicTable.prototype, "updateSelectedFields", null);
EconomicTable = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { TableBmk: bmk_ui_framework_1.TableBmk, TableHeader: bmk_ui_framework_1.TableHeader, TableHeaderCell: bmk_ui_framework_1.TableHeaderCell, TableBody: bmk_ui_framework_1.TableBody, TableBodyRow: bmk_ui_framework_1.TableBodyRow, TableBodyCell: bmk_ui_framework_1.TableBodyCell, CheckBox: bmk_ui_framework_1.CheckBox, ChevronsUpDown: lucide_vue_next_1.ChevronsUpDown, EBecropLogo: bmk_ui_framework_1.EBecropLogo }
    })
], EconomicTable);
exports.default = EconomicTable;
